import { Box, Tooltip } from '@chakra-ui/react';
// import { KMenuButton } from '@/ui-library/components/atoms/KMenuButton';
import { KText } from '@/ui-library/components';
import { Download01 } from '@kula-ai/icons/dual-tone/Download01';
import { useDownloadReports } from '@/hooks';
import { DownloadReports } from '@/pages/reports/custom-reports/show/headerActions/DownloadReports';
import { useKFlags } from '@/hooks/use-k-flags';
import { selectCurrUserPermission } from '@/store/bootstrap/selectors';
import { useSelector } from 'react-redux';
import { checkPermissions } from '@/ui/permission';
import { KButton } from '@/ui-library/components/atoms/KButton';

// interface DownloadOption {
//   id: string;
//   label: string;
// }

interface DownloadDataProps {
  reportData: any;
  drilldownData: any;
  isDisabled?: boolean;
}

export const DownloadData = ({
  reportData,
  drilldownData,
  isDisabled = false,
}: DownloadDataProps) => {
  const { handleDownloadCSV, isPolling } = useDownloadReports(reportData);
  const { reportsV2 } = useKFlags();
  const permissions = useSelector(selectCurrUserPermission);
  const isDownloadEnabled =
    checkPermissions(
      permissions,
      'api_ats_v1_reports_saved_report.generate?'
    ) &&
    checkPermissions(
      permissions,
      'api_ats_v1_reports_saved_report.download_reports?'
    );

  // const downloadOptions: DownloadOption[] = [
  //   { id: 'csv', label: 'Download CSV' },
  //   // { id: 'xls', label: 'Download XLS' },
  // ];

  const handleDownload = (id: string) => {
    if (id === 'csv') {
      handleDownloadCSV();
    } else if (id === 'xls') {
      // handleDownloadCSV('xls');
    }
  };

  const disableDownload = isDisabled || !isDownloadEnabled;

  if (!reportsV2) return null;

  return (
    <>
      <Box>
        <Tooltip
          label={
            !isDownloadEnabled
              ? "You don't have access to download data"
              : 'No data available to download'
          }
          placement="bottom"
          hasArrow
          isDisabled={!isDisabled && isDownloadEnabled}
        >
          <Box>
            <KButton
              icon={Download01}
              variant="quaternary"
              size="sm"
              onClick={() => handleDownload('csv')}
              isLoading={isPolling}
              disabled={disableDownload || isPolling}
              _focus={{
                bg: 'transparent',
              }}
              _disabled={{
                bg: 'secondary-100',
                cursor: 'not-allowed',
              }}
              opacity={disableDownload ? 0.5 : 1}
              _hover={{
                bg: disableDownload ? 'secondary-100' : 'transparent',
              }}
            >
              <KText size="sm-medium">Download CSV</KText>
            </KButton>
            {/* TODO */}
            {/* <KMenuButton
              _focus={{
                bg: 'transparent',
              }}
              _disabled={{
                bg: 'secondary-100',
                cursor: 'not-allowed',
              }}
              opacity={disableDownload ? 0.5 : 1}
              _hover={{
                bg: disableDownload ? 'secondary-100' : 'transparent',
              }}
              variant="quaternary"
              triggerContent={
                <Flex alignItems="center" gap="4px">
                  <Icon as={Download01} />
                  <KText size="sm-medium">Download data</KText>
                </Flex>
              }
              dividerProps={{
                display: 'none',
              }}
              disabled={disableDownload}
              menuContentProps={{
                borderRadius: 'sm',
                borderWidth: '1px',
                borderColor: 'border-color',
                p: '0',
                minW: '200px',
                boxShadow: 'none',
              }}
              menuContent={
                <>
                  {downloadOptions.map((option, index) => (
                    <MenuItem
                      key={option.id}
                      onClick={() => handleDownload(option.id)}
                      _hover={{ bg: 'secondary-25', borderRadius: 'sm' }}
                      py="10px"
                      px="16px"
                      borderTop={index !== 0 ? '1px solid' : 'none'}
                      borderTopColor="border-color"
                      borderRadius="0"
                    >
                      <KText size="sm-medium" color="secondary-700">
                        {option.label}
                      </KText>
                    </MenuItem>
                  ))}
                </>
              }
            /> */}
          </Box>
        </Tooltip>
      </Box>

      {isPolling && (
        <DownloadReports
          isPolling={isPolling}
          pollingText="Your CSV is being prepared"
        />
      )}
    </>
  );
};
